import { render, staticRenderFns } from "./TocSection.vue?vue&type=template&id=2cefaa1f&scoped=true&"
import script from "./TocSection.vue?vue&type=script&lang=js&"
export * from "./TocSection.vue?vue&type=script&lang=js&"
import style0 from "./TocSection.vue?vue&type=style&index=0&id=2cefaa1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefaa1f",
  null
  
)

export default component.exports